<template>
  <div class="register-layout">
    <div class="form-wrapper">
      <div class="logo-wrapper size-100">
        <router-link
          :to="{ name:'home' }"
        >
          <img src="@/assets/logo.svg" alt="">
        </router-link>
      </div>
      <router-view></router-view>
      <div class="has-text-centered disclaimer mb-15">
        <p class="is-size-7 has-text-grey-light">© {{ currentYear }} Global Martial Arts University and Hodgy LLC. All Rights Reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterLayout',
  metaInfo: {
    script: [
      {
        src: 'https://js.stripe.com/v3/',
        type: 'text/javascript'
      }
    ]
  },
  mounted () {
    this.setupSignupSession()
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  },
  methods: {
    setupSignupSession () {
      const session = this.$store.getters['register/signupSession']

      if (!session) {
        this.$store
          .dispatch('register/GET_SIGNUP_SESSION')
          .then(res => {
            this.$store.commit('register/saveSignupSession', res.data.sessionId)
          })
          .catch(err => {
            this.$toasted.error('Unable to setup signup session')
            console.log('error setting up signup session')
            console.log(err)
          })
      }
    }
  }
}
</script>

<style lang="scss">
  .form-wrapper{
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100vw;
    min-height: 100vh;
    height: 100%;
    z-index: 10;

    @include until($tablet) {
      align-items: flex-start;
      flex-direction: row;
      flex-wrap: wrap;

      .logo-wrapper, .disclaimer{
        display: none;
      }
    }

    .form-container{
      width: 550px;
      max-width: 550px;
      height: auto;
      padding: 1.5em 1em;
      box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
      border-radius: 4px;
      border: 4px solid $yellow;
      background: #FAFAFA;
      margin-bottom: 15px;

      @include until($tablet) {
        box-shadow: none;
        border-radius: 0px;
        margin-bottom: 0;
        border: 4px solid $primary-color;
      }
      .mt{
        margin-top: 15px;
      }
    }
  }
  .parent-data{
    padding: 15px;
    background: $gray-lighter;
    border-radius: 4px;
    margin-bottom: 15px;
  }
</style>
